<template>
  <div>
    <div class="card rounded-small shadow-sm" v-if="!is_admin">
      <div class="card-body text-center py-2">
        <p class="text-xs text-muted mb-0">
          <b>Academic Post-92 Check Verification</b> verifies qualifications
          issued after 1992.<br />
          Please complete the information <b>exactly as it appears</b> on your
          certificate.
        </p>
      </div>
    </div>
    <div class="form-group mt-3">
      <div v-if="is_admin" class="row">
        <div class="col-sm-6">
          <label for="names" class="fw-bold text-xs text-start d-block mt-3"
            >Names <span class="text-danger">*</span></label
          >
          <input
            v-model="names"
            type="text"
            class="form-control mx-auto text-xxs rounded-small p-2 shadow-sm"
            id="names"
            placeholder="Given names"
            required
          />
        </div>

        <div class="col-sm-6">
          <label for="surname" class="fw-bold text-xs text-start d-block mt-3"
            >Surname <span class="text-danger">*</span></label
          >
          <input
            v-model="surname"
            type="text"
            class="form-control mx-auto text-xxs rounded-small p-2 shadow-sm"
            id="surname"
            placeholder="Surname"
            required
          />
        </div>
      </div>

      <div v-else>
        <label for="names" class="fw-bold text-xs text-start d-block mt-3"
          >Names <span class="text-danger">*</span></label
        >
        <input
          v-model="names"
          type="text"
          class="form-control mx-auto col-12 col-md-9 col-lg-8 text-xxs rounded-small p-2 shadow-sm"
          id="names"
          placeholder="Given names"
          required
        />

        <label for="surname" class="fw-bold text-xs text-start d-block mt-3"
          >Surname <span class="text-danger">*</span></label
        >
        <input
          v-model="surname"
          type="text"
          class="form-control mx-auto col-12 col-md-9 col-lg-8 text-xxs rounded-small p-2 shadow-sm"
          id="surname"
          placeholder="Surname"
          required
        />
      </div>

      <div v-if="is_admin" class="row">
        <div class="col-sm-6">
          <label for="maiden_name" class="fw-bold text-xs text-start d-block mt-3"
            >Maiden Name</label
          >
          <input
            v-model="maiden_name"
            type="text"
            class="form-control mx-auto text-xxs rounded-small p-2 shadow-sm"
            id="maiden_name"
            placeholder="Maiden name"
          />
        </div>

        <div class="col-sm-6">
          <label for="id_number" class="fw-bold text-xs text-start d-block mt-3"
            >ID Number <span class="text-danger">*</span></label
          >
          <input
            v-model="id_number"
            type="text"
            class="form-control mx-auto text-xxs rounded-small p-2 shadow-sm"
            id="id_number"
            placeholder="e.g. 9812160854083"
            required
          />
        </div>
      </div>

      <div v-else>
        <label for="maiden_name" class="fw-bold text-xs text-start d-block mt-3"
          >Maiden Name</label
        >
        <input
          v-model="maiden_name"
          type="text"
          class="form-control mx-auto col-12 col-md-9 col-lg-8 text-xxs rounded-small p-2 shadow-sm"
          id="maiden_name"
          placeholder="Maiden name"
        />

        <label for="id_number" class="fw-bold text-xs text-start d-block mt-3"
          >ID Number <span class="text-danger">*</span></label
        >
        <input
          v-model="id_number"
          type="text"
          class="form-control mx-auto col-12 col-md-9 col-lg-8 text-xxs rounded-small p-2 shadow-sm"
          id="id_number"
          placeholder="e.g. 9812160854083"
          required
        />
      </div>

      <div v-if="is_admin" class="row">
        <div class="col-sm-6">
          <label for="date_of_birth" class="fw-bold text-xs text-start d-block mt-3"
            >Date of Birth <span class="text-danger">*</span></label
          >
          <input
            v-model="date_of_birth"
            type="text"
            class="form-control mx-auto text-xxs rounded-small p-2 shadow-sm"
            id="date_of_birth"
            placeholder="CCYYMMDD e.g. 19981216"
            required
          />
        </div>

        <div class="col-sm-6">
          <label for="document_number" class="fw-bold text-xs text-start d-block mt-3"
            >Document Number</label
          >
          <input
            v-model="document_number"
            type="text"
            class="form-control mx-auto text-xxs rounded-small p-2 shadow-sm"
            id="document_number"
            placeholder="e.g. 93063299137Y"
          />
        </div>
      </div>

      <div v-else>
        <label for="date_of_birth" class="fw-bold text-xs text-start d-block mt-3"
          >Date of Birth <span class="text-danger">*</span></label
        >
        <input
          v-model="date_of_birth"
          type="text"
          class="form-control mx-auto col-12 col-md-9 col-lg-8 text-xxs rounded-small p-2 shadow-sm"
          id="date_of_birth"
          placeholder="CCYYMMDD e.g. 19981216"
          required
        />

        <label for="document_number" class="fw-bold text-xs text-start d-block mt-3"
          >Document Number</label
        >
        <input
          v-model="document_number"
          type="text"
          class="form-control mx-auto col-12 col-md-9 col-lg-8 text-xxs rounded-small p-2 shadow-sm"
          id="document_number"
          placeholder="e.g. 93063299137Y"
        />
      </div>

      <div v-if="is_admin" class="row">
        <div class="col-sm-6">
          <label for="year" class="fw-bold text-xs text-start d-block mt-3"
            >Year Completed <span class="text-danger">*</span></label
          >
          <input
            v-model="year"
            type="text"
            class="form-control mx-auto text-xxs rounded-small p-2 shadow-sm"
            id="year"
            placeholder="CCYY e.g. 2020"
            required
          />
        </div>

        <div class="col-sm-6">
          <label for="document_type" class="fw-bold text-xs text-start d-block mt-3"
            >Qualification <span class="text-danger">*</span></label
          >
          <select
            v-model="document_type"
            class="form-control mx-auto text-xxs rounded-small p-2 shadow-sm"
            id="document_type"
            required
          >
            <option value="" hidden>Select Qualifications</option>
            <option
              v-for="doc in document_types.filter(
                (d) => d.code != '91' && d.role == 'certificate'
              )"
              :key="doc.code"
              :value="doc.code"
            >
              {{ doc.description }}
            </option>
          </select>
        </div>
      </div>

      <div v-else>
        <label for="year" class="fw-bold text-xs text-start d-block mt-3"
          >Year Completed <span class="text-danger">*</span></label
        >
        <input
          v-model="year"
          type="text"
          class="form-control mx-auto col-12 col-md-9 col-lg-8 text-xxs rounded-small p-2 shadow-sm"
          id="year"
          placeholder="CCYY e.g. 2020"
          required
        />

        <label for="document_type" class="fw-bold text-xs text-start d-block mt-3"
          >Qualification <span class="text-danger">*</span></label
        >
        <select
          v-model="document_type"
          class="form-control mx-auto col-12 col-md-9 col-lg-8 text-xxs rounded-small p-2 shadow-sm"
          id="document_type"
          required
        >
          <option value="" hidden>Select Qualifications</option>
          <option
            v-for="doc in document_types.filter(
              (d) => d.code != '91' && d.role == 'certificate'
            )"
            :key="doc.code"
            :value="doc.code"
          >
            {{ doc.description }}
          </option>
        </select>
      </div>

    <!-- Subjects section -->
    <div class="mt-3" v-if="add_subject">
      <label class="fw-bold text-xs text-start d-block">Subjects</label>
      <div
        v-for="(subject, index) in subjects_list"
        :key="index"
        class="d-flex align-items-center mb-2"
      >
        <select
          v-model="subject.subject_code"
          class="form-control text-xxs rounded-small p-2 shadow-sm me-2"
          style="flex: 1"
        >
          <option value="">Select Subject</option>
          <option v-for="subj in subjects" :key="subj.code" :value="subj.code">
            {{ subj.description }}
          </option>
        </select>
        <input
          v-model="subject.subject_performance"
          type="text"
          class="form-control text-xxs rounded-small p-2 shadow-sm me-2"
          placeholder="Performance"
          style="width: 100px"
        />
        <button @click="removeSubject(index)" class="btn btn-sm btn-danger">
          Remove
        </button>
      </div>
      <button @click="addSubject" class="btn btn-sm btn-secondary mt-2">
        Add Subject
      </button>
    </div>
  </div>
  </div>
</template>

<script>
import { PREPOPULATE_INPUT } from "@/utils/prepopulate_input.js";
import { API_BASE_URL } from "@/config";
import { validateToken } from "@/utils/auth";
import {
  validate_id,
  validate_document_number,
  validate_certificate_dob,
  validate_alphanumeric_with_spaces,
  validate_certificate_year,
  validate_qualification,
  validate_subject_code,
  validate_subject_performance,
} from "@/utils/validations";

export default {
  name: "AcademicCheckForm",
  mixins: [PREPOPULATE_INPUT],
  emits: ['submit'],
  data: () => ({
    id_number: "",
    document_number: "",
    date_of_birth: "",
    surname: "",
    names: "",
    maiden_name: "",
    year: "",
    document_type: "",
    document_types: [],
    subjects: [],
    subjects_list: [],
  }),
  props: {
    add_subject: {
      type: Boolean,
      default: false,
    },
    is_admin: {
      type: Boolean,
      default: false,
    },
    initial_data: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    workflow_id() {
      return this.$store.getters.get_workflow_id;
    },
  },
  watch: {
    initial_data: {
      immediate: true,
      deep: true,
      handler(new_data) {
        if (new_data) {
          this.id_number = new_data.id_number || "";
          this.document_number = new_data.document_number || "";
          this.date_of_birth = new_data.date_of_birth || "";
          this.surname = new_data.surname || "";
          this.names = new_data.names || "";
          this.maiden_name = new_data.maiden_name || "";
          this.year = new_data.year || "";
          this.document_type = new_data.qualification || "";
          this.subjects_list =
            new_data.subjects && Array.isArray(new_data.subjects)
              ? new_data.subjects
              : [];
        }
      },
    },
    id_number(newVal) {
      if (newVal && newVal.length === 13 && /^\d{13}$/.test(newVal)) {
        const yy = newVal.substring(0, 2);
        const mm = newVal.substring(2, 4);
        const dd = newVal.substring(4, 6);
        let year = parseInt(yy);
        if (year >= 50) {
          year += 1900;
        } else {
          year += 2000;
        }
        if (!this.date_of_birth) {
          // Only prepopulate if empty
          this.date_of_birth = `${year}${mm}${dd}`;
        }
      }
    },
  },
  methods: {
    submitForm() {
      const errors = [];

      // Validate ID Number
      if (!this.id_number || !validate_id(this.id_number)) {
        errors.push("Please enter a valid South African ID number.");
      }

      // Validate Document Number
      if (
        this.document_number &&
        !validate_document_number(this.document_number)
      ) {
        errors.push(
          "Document number must be exactly 12 alphanumeric characters with 11 digits and 1 letter (e.g. 93063299137Y)."
        );
      }

      // Validate Date of Birth
      if (
        !this.date_of_birth ||
        !validate_certificate_dob(this.date_of_birth)
      ) {
        errors.push(
          "Date of Birth must be in CCYYMMDD format and a valid past date (e.g. 19981216)."
        );
      }

      // Validate Surname
      if (!this.surname || !validate_alphanumeric_with_spaces(this.surname)) {
        errors.push(
          "Surname must contain only letters, digits, and spaces, up to 55 characters."
        );
      }

      // Validate Names
      if (!this.names || !validate_alphanumeric_with_spaces(this.names)) {
        errors.push(
          "Names must contain only letters, digits, and spaces, up to 55 characters."
        );
      }

      // Validate Maiden Name
      if (
        this.maiden_name &&
        !validate_alphanumeric_with_spaces(this.maiden_name)
      ) {
        errors.push(
          "Maiden name must contain only letters, digits, and spaces, up to 55 characters."
        );
      }

      // Validate Year
      if (!this.year || !validate_certificate_year(this.year)) {
        errors.push(
          "Year must be a 4-digit number between 1900 and current year."
        );
      }

      // Validate Qualification
      if (!this.document_type || !validate_qualification(this.document_type)) {
        errors.push("Please select a valid qualification code.");
      }

      // Validate Subjects
      const validSubjects = this.subjects_list.filter(
        (s) => s.subject_code && s.subject_performance
      );
      for (const subject of validSubjects) {
        if (!validate_subject_code(subject.subject_code)) {
          errors.push(
            `Subject code '${subject.subject_code}' must be exactly 4 digits.`
          );
        }
        if (!validate_subject_performance(subject.subject_performance)) {
          errors.push(
            `Subject performance '${subject.subject_performance}' must be exactly 2 alphanumeric characters.`
          );
        }
      }

      // Cross-field validations
      if (!this.id_number && !this.document_number) {
        errors.push(
          "At least one of ID Number or Document Number must be provided."
        );
      }

      if (validSubjects.length > 0 && !this.document_number) {
        errors.push(
          "Subjects can only be provided when Document Number is given."
        );
      }

      if (errors.length > 0) {
        Swal.fire({
          icon: "error",
          title: "Validation Errors",
          html: errors.join("<br>"),
        });
        return;
      }

      const formData = {
        id_number: this.id_number,
        document_number: this.document_number,
        date_of_birth: this.date_of_birth,
        surname: this.surname,
        names: this.names,
        maiden_name: this.maiden_name,
        year: this.year,
        qualification: this.document_type,
        subjects: validSubjects,
        workflow_id: this.workflow_id,
        on_behalf_application:
          this.$route.name === "behalf_application" ? true : false,
      };
      this.$emit("submit", formData);
    },
    fetchDocumentTypes() {
      const TOKEN = localStorage.getItem("token");
      const API_URL = `${API_BASE_URL}/verify_api/background_screening/academic_check/get-document-types/`;

      $.ajax({
        url: API_URL,
        method: "GET",
        headers: {
          Authorization: `Token ${TOKEN}`,
        },
        success: (response) => {
          if (response.status === "success") {
            this.document_types = response.data.document_types;
          }
        },
        error: (error) => {
          console.error("Error fetching document types:", error);
        },
      });
    },
    fetchSubjects() {
      const TOKEN = localStorage.getItem("token");
      const API_URL = `${API_BASE_URL}/verify_api/background_screening/academic_check/get-subjects/`;

      $.ajax({
        url: API_URL,
        method: "GET",
        headers: {
          Authorization: `Token ${TOKEN}`,
        },
        success: (response) => {
          if (response.status === "success") {
            this.subjects = response.data.subjects;
          }
        },
        error: (error) => {
          console.error("Error fetching subjects:", error);
        },
      });
    },
    addSubject() {
      this.subjects_list.push({ subject_code: "", subject_performance: "" });
    },
    removeSubject(index) {
      this.subjects_list.splice(index, 1);
    },
  },
  mounted() {
    if (!validateToken(this.$router)) {
      return;
    }
    if (!this.is_admin) {
      this.get_customer_data();
    }
    this.fetchDocumentTypes();
    this.fetchSubjects();
  },
};
</script>
